import React, { Component } from "react";
import forOwn from "mout/object/forOwn";
import { Col, Label, Dropdown, DropdownToggle } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import values from 'mout/object/values'
import isLicensedUser from '../../../helpers/users/licenses/isLicensedUser'
import getSchoolYear from '../../../helpers/getSchoolYear'
import determineSchoolYear from '../../../helpers/determineSchoolYear'

class SearchDropdownStudent extends Component {
  state = { 
    dropdownOpen: false, 
    filter: "" , 
    disableDropdown: false,
    students: null,
    loadingLicenses: false,
    licensedUsers: [],
    licenseEndDate: null
  };

  componentDidMount(){
    const { groupData, gDataKey } = this.props;
    const students = values(groupData[gDataKey]);

    isLicensedUser(students, this.setState.bind(this))
    this.setState({students: groupData[gDataKey]})
  }

  toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });
  changeFilter = ({ target }) => this.setState({ filter: target.value });

  
  changeFilterData = slectedOption => {
    const { Class, itemNumber, selectGroupUA, selectStudent } = this.props;
    let id = slectedOption.key;
    //selectStudent("");
    if (id === Class) {
      if (typeof itemNumber === "undefined") {
        selectGroupUA(Class);
      } else {
        selectGroupUA(Class, itemNumber);
      }
    } else {
      selectStudent(id);
    }
    if (slectedOption.label === "---") {
      slectedOption.label = "";
    }
    this.setState({ filter: "", dropdownOpen: false});
    this.props.selectStudentOption(slectedOption);
  };

  render() {
    const {
      Class,
      gDataKey,
      groupData,
      selectedStudent,
      selectStudent,
      userAssessment,
      isAssessmentInitializing,
      year
    } = this.props;

    const { dropdownOpen, filter,disableDropdown } = this.state;

    const { toggle } = this;
    const options = [];
    options.push({
      value: "---",
      label: "---",
      key: Class
    });
    const students = this.state.students;
    const thisGroupData = groupData.classes;
    const thisClass = thisGroupData[Class];
    if(students) {
    forOwn(thisClass.students, (val, key) => {
      if (val && students[key]) {
        const thisStudent = students[key];
        if (
          !filter ||
          (thisStudent.fullName &&
            thisStudent.fullName.toLowerCase().indexOf(filter.toLowerCase()) >
              -1) && 
          (this.state.licensedUsers.includes(thisStudent.id) && 
          determineSchoolYear(this.state.licenseEndDate).split('sy')[1] >= 
          getSchoolYear().year.split('sy')[1] && getSchoolYear().year == year) || 
          determineSchoolYear(thisStudent.created) === year
        ) {
          options.push({
            value: students[key].fullName,
            label: students[key].fullName,
            key: key
          });
        }
      }
    });
  }
    const selectWidthControl = {
      minWidth: "190px"
    };

    const placeholder = selectedStudent === "" && Class ? "" : "";
    let selectedOption = this.props.student_selected_value;
    if(selectedOption===null)
    {
      options.forEach(option => {
        if(option.key===selectedStudent)
        {
          selectedOption = option;
        }
      });
    }

    return (
      <Col xl="2" lg="2" md="6" sm="12" style={selectWidthControl}>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle
            tag="span"
            onClick={toggle}
            data-toggle="dropdown"
            aria-expanded={dropdownOpen}
          >
            <Label>{`Students:`}</Label>

            <Select
              value={selectedOption}
              placeholder={placeholder}
              options={options}
              onChange={this.changeFilterData}
              isDisabled={isAssessmentInitializing}
            />
          </DropdownToggle>
        </Dropdown>
      </Col>
    );
  }
}
const mapStatetoProps = state => {
  return {
    student_selected_value: state.users.student_selected_value
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectStudentOption: selectedValue => {
      dispatch({
        type: "STUDENT_SELECTED_DROPDOWN",
        value: selectedValue
      });
    }
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(SearchDropdownStudent);


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSelectorBar/SearchDropdownStudent.js